<div class="row">
  <div class="col-xl-10">
    <app-base-edit-form
      [fields]="fields"
      [id]="purchaseOrderLineId"
      [parentId]="purchaseOrderHeaderId"
      [baseService]="purchaseOrderLineService"
      (saved)="saved()"
    >
    </app-base-edit-form>
  </div>
  <div class="col-xl-2">
    @if (productDetails) {
      <app-product-logo [product]="productDetails" [showBrowse]="false" [showRemove]="false"></app-product-logo>
    }
  </div>
</div>

<div class="row">
  <div class="col-xl-4">
    <app-readonly-grid
      i18n-header
      header="Order Line Status"
      stateKey="PurchaseOrderLineDetailsOrderLineStatus"
      [columnDefs]="columnDefs"
      [rowData]="model?.purchaseOrderLineStatusItems || []"
    ></app-readonly-grid>
  </div>
  <div class="col-xl-4">
    <app-readonly-grid
      i18n-header
      header="Sales Order Allocations"
      gridCssClass="sales-order-allocations-grid"
      stateKey="PurchaseOrderLineDetailsSalesOrderAllocations"
      [columnDefs]="columnSalesAllocDefs"
      [rowData]="model?.purchaseOrderAllocations || []"
    ></app-readonly-grid>
  </div>
  <div class="col-xl-4">
    <app-readonly-grid
      i18n-header
      header="Purchase Order Allocations"
      gridCssClass="purchase-order-allocations-grid"
      stateKey="PurchaseOrderLineDetailsPurchaseOrderAllocations"
      [columnDefs]="columnPurchaseAllocDefs"
      [rowData]="model?.purchaseOrderPurchaseAllocations || []"
    ></app-readonly-grid>
  </div>
</div>
